module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-360cf20a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebars/SchoolSideMenu.vue
// module id = 1853
// module chunks = 1